<template>
  <v-app id="inspire">
    <v-main>
      <v-container v-if="friendsSelection.length === 0">
        <v-row
          justify="center"
          align="center"
          style="margin-top: 5%"
        >
        <h1>Welcome to Spuffle!</h1>
          <v-col class="shrink">
            <v-icon large>mdi-shuffle</v-icon>
          </v-col>
        </v-row>
        <v-row
          justify="center"
          >
          <p>
            This is a simple shuffle assistant for the public playlists of you and your friends.<br>
            We use your public playlists to find your friends and the people you are hanging right now.<br>
            You can find to your left in the menu.<br>
            By clicking on each of the avatars, you magically compose a playlist with songs of your friends.<br><br><br>
            <b>In case you are missing someone:</b><br>Start following a playlist of your friend, and make it public in the Spotify App!<br>
          </p>
        </v-row>
        <v-row
          justify="center"
          align="center"
        >
          <h2>TL;DR: How does it work?</h2>
        </v-row>
        <v-row
          justify="center"
          align="center"
        >
          <ol>
            <li>Login</li>
            <li>Select the people you are with in the left menu</li>
            <li>Let us automatically create a playlist for you</li>
          </ol>
        </v-row>
        <v-row
          justify="center"
          align="center"
        >
          <h3>Have a great time listening to all your favourites!</h3>
        </v-row>
      </v-container>
      <v-container v-if="friendsSelection.length !== 0">
        <v-row
          justify="center"
          align="center"
          style="margin-top: 5%"
        >
          <v-card
            max-width="900"
            class="mx-auto"
          >
            <v-list disabled two-line>
             <v-list-item-group>
               <template v-for="(item, index) in friendsSelection">
                 <v-list-item :key="item.id">
                    <template>
                    <v-list-item-avatar>
                      <v-img
                        :src="item.imageUrl"
                        alt=""
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-icon color="green">mdi-account-circle-outline</v-icon>
                          </v-row>
                        </template>
                      </v-img>
                    </v-list-item-avatar>
                     <v-list-item-content>
                       <v-list-item-title v-text="item.display_name"></v-list-item-title>
                       <v-list-item-subtitle v-text="item.display_name"></v-list-item-subtitle>
                     </v-list-item-content>
                     <v-list-item-action>
                       <v-list-item-action-text v-text="item.display_name"></v-list-item-action-text>
                     </v-list-item-action>
                   </template>
                 </v-list-item>
                 <v-divider
                   v-if="index + 1 < friendsSelection .length"
                   :key="index"
                 ></v-divider>
               </template>
             </v-list-item-group>
            </v-list>
          </v-card>
        </v-row>
      </v-container>
      <v-row align="center" v-if="friendsSelection.length !== 0">
        <v-col class="text-center" cols="12" sm="4">
            <v-btn large outlined color="red" @click="reset()">Reset</v-btn>
        </v-col>
        <v-col class="text-center" cols="12" sm="4">
            <!-- <v-btn large outlined color="green">Get common songs</v-btn> -->
        </v-col>
        <v-col class="text-center" cols="12" sm="4">
          <div class="my-2">
            <v-btn large color="green" @click="shuffle()">Shuffle a list</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  }),
  computed: {
    ...mapGetters({
      playlistsOwners: 'getPlaylistOwners',
      friendsSelection: 'getFriendsSelection',
      authToken: 'getUserToken',
      playlists: 'getPlaylists'
    })
  },
  methods: {
    reset () {
      this.$store.commit('resetFriends')
    },
    async shuffle () {
      await this.$store.dispatch('getRandomPlaylistForFriendsSelection')
      this.$router.push('/newplaylist')
    }
  },
  created () {
    this.$vuetify.theme.dark = true
  },
  mounted () {
    if (this.authToken && this.playlists === []) {
      this.$store.dispatch('fetchFollows')
    }
  }
}
</script>
